<template>
  <div
    v-if="show"
    class="loader loader-border"
  >
    <span
      class="bounce1"
      :class="[variant != undefined ? bgColor : 'bg-primary']"
      :style="{ width: sizePixels, height: sizePixels }"
    />
    <span
      class="bounce2"
      :class="[variant != undefined ? bgColor : 'bg-primary']"
      :style="{ width: sizePixels, height: sizePixels }"
    />
    <span
      class="bounce3"
      :class="[variant != undefined ? bgColor : 'bg-primary']"
      :style="{ width: sizePixels, height: sizePixels }"
    />
  </div>
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    size: {
      type: Number,
    },
    show: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      sizePixels: `${this.size}px`,
      bgColor: `bg-${this.variant}`,
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/components/_loader.scss';
</style>
